import ConfigForm, {
  ConfigInput,
  FormOption,
} from "components/Layout/ConfigForm";
import { FloorOverlay, PoiType } from "generated/graphql";
import React from "react";

interface AddEditPoiProps {
  handlePoiTypeChange: () => void;
  poiTypes: PoiType[];
  type?: string;
  handleNewLocation: (lat: number, lng: number, floorNumber: number) => void;
  floorOverlays: Pick<
    FloorOverlay,
    | "BuildingId"
    | "CenterLat"
    | "CenterLng"
    | "D_diff"
    | "FloorNumber"
    | "Id"
    | "ImageUrl"
    | "Name"
    | "Rot"
    | "created_at"
    | "k_diff"
    | "updated_at"
    | "AndroidFloors"
  >[];
}

export default function AddEditPoi({
  handlePoiTypeChange,
  handleNewLocation,
  floorOverlays,
  type,
  poiTypes,
}: AddEditPoiProps) {
  const typeInputs = poiTypes?.map((poiType) => {
    return {
      value: poiType.id,
      label: poiType.title,
    };
  });
  const inputs: ConfigInput[] = [
    {
      title: "Select POI Type",
      type: "select",
      onChange: handlePoiTypeChange,
      xs: 12,
      sm: 6,
      id: "poiType",
      placeholder: "select POI type",
      options: typeInputs,
      value: type,
    },
    {
      title: "Select the POI Location",
      type: "mapPoint",
      onNewLocation: handleNewLocation,
      onChange: () => {},
      floorOverlays,
      xs: 12,
      sm: 6,
      id: "stepMap",
    },
  ];

  return <ConfigForm inputs={inputs} />;
}
